import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { Grid, FormControlLabel, Checkbox } from '@material-ui/core'
import { useLazyQuery, useQuery } from '@apollo/client'
import { FilterDropdown } from '../components/FilterDropdown'
import { SearchBar } from './SearchBar'

import GetDepartmentInfo from '../graphql/queries/getDepartmentInfo.gql'
import GetMembers from '../graphql/queries/getUsers.gql'

const StyledGrid = styled(Grid)`
  margin-bottom: 15px;
  position: sticky;
  top: -10px;
  background: #fff;
  z-index: 1;
`

const FilterGrid = styled(Grid)`
  margin-left: 15px;
`

const DefaultVariables = {
  search: '',
  selectedDepartmentIds: [],
  adminPositionListIds: [],
}

export const SearchUser = ({
  departmentId,
  organizationId,
  isOrganizer,
  selectAll,
  handleSelect,
  setMembers,
  settings,
}) => {
  const [variables, setVariables] = useState(DefaultVariables)
  const [filterOptions, setFilterOptions] = useState([])
  const [mounted, setMounted] = useState(!isOrganizer)

  useQuery(GetDepartmentInfo, {
    variables: {
      departmentId,
    },
    skip: !isOrganizer,
    onCompleted: ({ currentUser }) => {
      const { isFacility, adminPositionLists, childrenDepartments } = currentUser.currentDepartment
      const options = []
      if (adminPositionLists.length > 0) {
        options.push({
          name: 'positions',
          options: adminPositionLists,
          selectedType: 'id',
          optionText: 'name',
          dataType: 'adminPositionListIds',
          checkAllText: 'All Positions',
          showName: true,
        })
      }
      if (isFacility && childrenDepartments.length > 0) {
        options.push({
          name: 'departments',
          options: childrenDepartments,
          selectedType: 'id',
          optionText: 'name',
          dataType: 'selectedDepartmentIds',
          checkAllText: 'All Departments',
          showName: true,
        })
      }
      setVariables((prev) => ({
        ...prev,
        adminPositionListIds: adminPositionLists.map((pos) => pos.id),
        selectedDepartmentIds: isFacility ? childrenDepartments.map((dep) => dep.id) : [],
      }))
      setFilterOptions(options)
      setMounted(true)
    },
  })

  const [getMembers] = useLazyQuery(GetMembers, {
    fetchPolicy: 'cache-and-network',
    onCompleted: ({ currentUser }) => {
      setMembers(currentUser.usersAbleToChat)
    },
  })

  const handleChangeSearch = (val) => {
    setVariables((prev) => ({ ...prev, page: 1, search: val }))
  }

  const handleOnChangeFilter = (listValue, key) => (e) => {
    let val = null
    if (e.target.value.includes('all')) {
      if (variables[key].toString() === listValue.toString()) {
        val = []
      } else {
        val = listValue
      }
    } else {
      val = e.target.value
    }
    setVariables((prev) => ({ ...prev, page: 1, [key]: val }))
  }

  useEffect(() => {
    if (mounted) {
      const { search, adminPositionListIds, selectedDepartmentIds } = variables
      getMembers({
        variables: {
          organizationId,
          departmentId,
          search,
          adminPositionListIds: adminPositionListIds.length === 0 ? null : adminPositionListIds,
          selectedDepartmentIds: selectedDepartmentIds.length === 0 ? null : selectedDepartmentIds,
        },
      })
    }
  }, [variables, mounted, organizationId, departmentId, getMembers, settings])

  return (
    <StyledGrid container alignItems="center">
      {isOrganizer && (
        <FilterGrid item container xs={9}>
          <Grid item xs={6}>
            <FilterDropdown
              options={filterOptions}
              value={variables}
              handleOnChangeFilter={handleOnChangeFilter}
            />
          </Grid>
        </FilterGrid>
      )}
      <Grid item xs={isOrganizer ? 9 : 12}>
        <SearchBar search={variables.search} setSearch={handleChangeSearch} />
      </Grid>
      {isOrganizer && (
        <Grid item xs={3} textAlign="right">
          <FormControlLabel
            control={(
              <Checkbox
                checked={selectAll || false}
                onChange={handleSelect}
                name="selectAll"
                color="primary"
              />
            )}
            label="All"
          />
        </Grid>
      )}
    </StyledGrid>
  )
}
